import { createContext, useContext } from 'react';

interface SidebarContextType {
  toggleSidebar: () => void;
  isSidebarCollapsed: boolean;
}

const SidebarContext = createContext<SidebarContextType | null>(null);

export const SidebarProvider = SidebarContext.Provider;

export const useSidebarContext = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    // Return a no-op function if context is not available
    return {
      toggleSidebar: () => {},
      isSidebarCollapsed: false
    };
  }
  return context;
};
